import React from 'react';

interface IInfoProps {
  children: React.ReactNode;
}

const Info: React.FC<IInfoProps> = props => {
  return <div className="info_msg">{props.children}</div>;
};

export default Info;
